<template lang="pug">
div
  .seo
    template(v-if="getLanguage==='en'")
      .con
        h2 Top Slot Game Platform
        p Explore an extensive selection of Slot Games sourced from renowned vendors worldwide. Engage with award-winning slot games through our internationally acclaimed, game-centric platform – an exclusive experience brought to you solely by Epicwin!
      .con
        h2 Affiliate Partnership with Epicwin 
        p Here at Epicwin Affiliates, we acknowledge the paramount importance of our affiliate partners. Our amiable and skilled team is dedicated to supporting you throughout your endeavor to generate profits alongside us. Embark on your journey with us today!
    template(v-else)
      .con
        h2 Pinakamahusay na Plataporma ng Laro ng Slot
        p Tuklasin ang malawak na pagpili ng mga Laro sa Slot mula sa kilalang mga tagapagbigay sa buong mundo. Makilahok sa mga nagwaging laro sa slot gamit ang aming pandaigdigang kilalang plataporma ng laro – isang eksklusibong karanasan na inihahatid sa iyo lamang ng Epicwin!
      .con
        h2 Kasosyo sa Affiliate Program ng Epicwin
        p Narito sa mga Kasosyo ng Epicwin Affiliates, inaamin namin ang napakahalagang papel ng aming mga affiliate partner. Ang aming magiliw at mahuhusay na koponan ay nakatuon na suportahan ka sa buong paglalakbay mo upang magkaroon ng kita kasama kami. Simulan ang iyong paglalakbay sa amin ngayon!
</template>
<script>
export default {
  computed:{
    getLanguage() {
      return this.$store.getters.language || "en"
    },
    getFbLink(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'facebook'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
    getTgLink(){
      if(this.$store.getters.getSocialList.length> 0){
        for(var x = 0; x < this.$store.getters.getSocialList.length; x++){
          if(this.$store.getters.getSocialList[x].social_platform === 'telegram'){
            return this.$store.getters.getSocialList[x].social_link
          }
        }
        return ""
      }else{
        return ""
      }
    },
  }
}
</script>